module.exports = __webpack_public_path__ + "static/gigidalessio-e31c7f6edde10ead626b659b154f3ee6.png";